import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CurrencyComponent } from '../currency/currency.component';
import { EventsService, VariablesService } from 'src/app/shared/services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sip-pitch-otd',
  standalone: true,
  imports: [CommonModule, CurrencyComponent, NgOptimizedImage],
  templateUrl: './sip-pitch-otd.component.html',
  styleUrls: ['./sip-pitch-otd.component.scss']
})
export class SipPitchOtdComponent implements OnChanges {
  private readonly actRoute = inject(ActivatedRoute);
  private readonly events = inject(EventsService);
  readonly vars = inject(VariablesService);

  @Input() currency;

  isChecked = false;
  displayAmt = 0;

  amounts = { USD: 15, GBP: 10, EUR: 5, AED: 30, SAR: 15, SGD: 10, CAD: 5, HKD: 20, QAR: 10, AUD: 10, MYR: 10 };

  params = { ...this.actRoute.snapshot.queryParams };

  ngOnInit() {
    console.log('app-sip-pitch-otd init', this.vars.selectedOtdSipAmt);
    if (this.params?.st === 'f' && (+this.params?.otd_sip) === this.amounts[this.currency]) {
      this.isChecked = true;
      this.setValue();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.vars.selectedOtdSipAmt) {
      this.isChecked = true;
    }
    if (changes?.['currency'] && (changes?.['currency']?.currentValue !== changes?.['currency']?.previousValue)) {
      this.displayAmt = Object.keys(this.amounts).includes(this.currency) ? this.amounts[this.currency] : 5;
      this.setValue();
    }
  }

  onCheck() {
    this.isChecked = !this.isChecked;
    this.setValue();
    this.events.sendSystemEvent({ eventName: 'otd_sip_click', info_1: `${this.isChecked}`, info_2: this.currency }).subscribe(_ => _);
  }

  setValue() {
    this.vars.selectedOtdSipAmt = this.isChecked ? this.displayAmt : 0;
  }

  ngOnDestroy() {
    console.log('app-sip-pitch-otd destroy');
  }
}
